/**
 * Kontrol — gclid / fbclid / ttclid attribution capture.
 *
 * On every page load:
 *   1. Read the three click-ID params from window.location.search.
 *   2. For any value we just captured, set a first-party cookie
 *      (_k_gclid / _k_fbclid / _k_ttclid, 90-day TTL).
 *   3. POST the freshly-captured values to /cart/update.js so they ride
 *      through to the order as note_attributes.
 *   4. Expose window.kontrolAttribution.{get,all} so track.js can merge
 *      click IDs into every dispatched event.
 *
 * Spec: docs/superpowers/specs/2026-05-20-shopify-tracking-port-design.md §4.1
 */
(function () {
  "use strict";

  var PARAMS = ["gclid", "fbclid", "ttclid"];
  var COOKIE_PREFIX = "_k_";
  var TTL_SECONDS = 60 * 60 * 24 * 90; // 90 days

  function readCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].substring(prefix.length));
      }
    }
    return null;
  }

  function writeCookie(name, value) {
    var v = encodeURIComponent(value);
    document.cookie =
      name + "=" + v +
      "; Max-Age=" + TTL_SECONDS +
      "; Path=/" +
      "; SameSite=Lax" +
      "; Secure";
  }

  // 1) Read URL params + persist
  var search = new URLSearchParams(window.location.search);
  var fresh = {};
  for (var i = 0; i < PARAMS.length; i++) {
    var p = PARAMS[i];
    var v = search.get(p);
    if (v && v.length > 0) {
      writeCookie(COOKIE_PREFIX + p, v);
      fresh[p] = v;
    }
  }

  // 2) Sync to cart.attributes when something new was captured
  var freshKeys = Object.keys(fresh);
  if (freshKeys.length > 0) {
    var body = freshKeys
      .map(function (k) {
        return "attributes[" + encodeURIComponent(k) + "]=" + encodeURIComponent(fresh[k]);
      })
      .join("&");
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body,
      keepalive: true,
    }).catch(function () {
      // Best-effort — losing this on first paint is acceptable; cookie still holds the value.
    });
  }

  // 3) Expose for track.js
  window.kontrolAttribution = {
    get: function (name) {
      return readCookie(COOKIE_PREFIX + name);
    },
    all: function () {
      var out = {};
      for (var i = 0; i < PARAMS.length; i++) {
        var p = PARAMS[i];
        var v = readCookie(COOKIE_PREFIX + p);
        if (v) out[p] = v;
      }
      return out;
    },
  };
})();
